import { useEffect, useState } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import DataTable from "monitor/Tables/DataTable"
import Icon from "@mui/material/Icon"
import { Link, useNavigate } from "react-router-dom"
import config from "config"
import MDButton from "components/MDButton"
import Chip from "@mui/material/Chip"

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import { TextField } from "@mui/material"
import MDTypography from "components/MDTypography"

function Empresas() {
  const [data, setData] = useState([])
  const [nombre, setNombre] = useState("")
  const navigate = useNavigate()

  const columns = [
    { Header: "Item", accessor: "item", width: "5%" },
    { Header: "Razon Social", accessor: "descripcion", width: "10%" },
    { Header: "Activo", accessor: "activo", width: "10%" },
    { Header: "Acciones", accessor: "action", align: "center", width: "10%" },
  ]

  const handleNombreSearch = (event) => {
    const term = event.target.value
    setNombre(term)
  }

  const fetchEmpresas = async (setData) => {
    try {
      let url = `${config.api.baseURL}/empresas?`

      if (nombre) {
        url += `nombre=${encodeURIComponent(nombre)}`
      }

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        addColumns(result)
        setData(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  function addColumns(dataColumns) {
    let c = 0
    dataColumns.map((d) => {
      const { id } = d
      d.action = (
        <MDBox>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="success"
            iconOnly
            onClick={() => handleEdit(d.idEmpresa)}
          >
            <Icon>edit</Icon>
          </MDButton>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="warning"
            iconOnly
            onClick={() => handleServices(d.idEmpresa)}
          >
            <Icon>miscellaneous_services_icon</Icon>
          </MDButton>
          <MDButton
            sx={{ mr: 1, backgroundColor: "#3f51b5", color: "#fff", "&:hover": { backgroundColor: "#32408f" } }}
            variant="gradient"
            iconOnly
            onClick={() => handleDiccionario(d.idEmpresa)}
          >
            <Icon>tune</Icon>
          </MDButton>
          <MDButton
            variant="gradient"
            color="error"
            iconOnly
            onClick={() => handleDelete(d.idEmpresa)}
          >
            <Icon>delete</Icon>
          </MDButton>
        </MDBox>
      )
      d.activo
        ? (d.activo = <Chip label="Si" color="success" variant="outlined" />)
        : (d.activo = <Chip label="No" color="error" variant="outlined" />)
      d.item = ++c
    })
    return dataColumns
  }

  function handleDelete(id) {
    Swal.fire({
      title: "¿Está seguro que desea eliminar esta empresa?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = `${config.api.baseURL}/empresas/${id}?`

        if (nombre) {
          url += `nombre=${encodeURIComponent(nombre)}`
        }

        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Empresa eliminado exitosamente", icon: "success" })
              fetchEmpresas(setData)
            } else {
              showToast({
                icon: "error",
                title: "Error",
                text: response.body.error || "No se pudo eliminar la empresa.",
              })
            }
          })
          .catch((error) => {
            const err = error.message
            showToast({ icon: "error", title: "Error", text: err })
          })
      }
    })
  }

  const resetValues = () => {
    setNombre("")
  }

  const handleClearFilters = () => {
    resetValues() // Reset all filter states
  }

  const handleBuscar = async () => {
    await fetchEmpresas(setData)
  }

  function handleEdit(id) {
    navigate(`/empresas/${id}`)
  }

  function handleServices(id) {
    navigate(`/empresas/${id}/servicios`)
  }

  function handleDiccionario(id) {
    navigate(`/empresas/${id}/diccionario`)
  }

  useEffect(() => {
    fetchEmpresas(setData)
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={5} pb={3}>
        <Grid container>
          <Grid item xs={12}>
            <Card sx={{ p: 2, mb: 3 }}>
              <MDTypography variant="h6" color="text" gutterBottom>
                Filtros
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    value={nombre}
                    onChange={handleNombreSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleNombreSearch(event)
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <MDBox>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        onClick={handleBuscar}
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={handleClearFilters}
                      >
                        Limpiar
                      </MDButton>
                    </MDBox>

                    <Link to="/empresas/agregar" style={{ textDecoration: "none" }}>
                      <MDButton type="button" variant="gradient" color="success">
                        Agregar
                      </MDButton>
                    </Link>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
            <Card>
              <MDBox pt={3}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Empresas
